module.exports = __webpack_public_path__ + "static/screenshots-c4892a1eb96544201f88d8172b702715.svg";